<template>
    <main v-if="currentNews">
        <article class="wrapper">
            <div class="left">
                <h1
                    v-if="currentNews?.title_ru"
                    v-html="
                        $i18n.locale == 'ru'
                            ? currentNews.title_ru
                            : currentNews.title_uz
                    "
                ></h1>
                <div class="flexCont">
                    <div class="date">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 512 512"
                        >
                            <rect
                                width="416"
                                height="384"
                                x="48"
                                y="80"
                                fill="none"
                                stroke="currentColor"
                                stroke-linejoin="round"
                                stroke-width="32"
                                rx="48"
                            />
                            <circle
                                cx="296"
                                cy="232"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="376"
                                cy="232"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="296"
                                cy="312"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="376"
                                cy="312"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="136"
                                cy="312"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="216"
                                cy="312"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="136"
                                cy="392"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="216"
                                cy="392"
                                r="24"
                                fill="currentColor"
                            />
                            <circle
                                cx="296"
                                cy="392"
                                r="24"
                                fill="currentColor"
                            />
                            <path
                                fill="none"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="32"
                                d="M128 48v32m256-32v32"
                            />
                            <path
                                fill="none"
                                stroke="currentColor"
                                stroke-linejoin="round"
                                stroke-width="32"
                                d="M464 160H48"
                            />
                        </svg>
                        {{ normalizeDate(currentNews?.created_at) }}
                    </div>
                    <Share dir="top" className="mobile notext" />
                </div>
                <div
                    v-if="currentNews?.desc_full_ru"
                    class="article"
                    v-html="
                        $i18n.locale == 'ru'
                            ? currentNews?.desc_full_ru
                            : currentNews?.desc_full_uz
                    "
                ></div>
                <Share dir="ltr" className="desctop" />
            </div>
            <div class="right">
                <img
                    :src="
                        'https://api.tvcom.uz/' +
                        ($i18n.locale == 'ru'
                            ? currentNews.img_ru
                            : currentNews.img_uz)
                    "
                    :alt="
                        $i18n.locale == 'ru'
                            ? currentNews.title_ru
                            : currentNews.title_uz
                    "
                />
            </div>
        </article>
    </main>
</template>
<script>
import { getCurrentNews } from "../../Api";
import Share from "../../components/Share.vue";
export default {
    components: {
        Share,
    },
    props: ["id"],
    data() {
        return {
            news: [],
            currentNews: null,
            isClipBoard: false,
        };
    },

    mounted() {
        this.loadList();
        if (this.$route.params.lang == "uz") {
            localStorage.setItem("lang", "uz");
            this.$i18n.locale = "uz";
        } else {
            localStorage.setItem("lang", "ru");
            this.$i18n.locale = "ru";
        }
    },
    methods: {
        async loadList() {
            const currentNews = await getCurrentNews(this.id);
            this.currentNews = currentNews;
            // if (currentNews?.seo_ru) {
            //     document
            //         .querySelector('meta[name="description"]')
            //         .setAttribute(
            //             "content",
            //             this.$i18n.locale == "ru"
            //                 ? currentNews?.seo_ru
            //                 : currentNews?.seo_uz
            //         );
            // }
            // if (currentNews?.title_ru) {
            //     document.title =
            //         this.$i18n.locale == "ru"
            //             ? currentNews?.title_ru
            //             : currentNews?.title_uz;
            // }
        },
        normalizeDate(dateTime) {
            const date = new Date(dateTime);

            const formattedDate = date
                .toISOString()
                .split("T")[0]
                .split("-")
                .reverse()
                .join(".");
            return formattedDate;
        },
        async copyLink() {
            if (navigator.share) {
                await navigator
                    .share({
                        title:
                            "Ссылка на " + this.$i18n.locale == "ru"
                                ? this.currentNews.title_ru
                                : this.currentNews.title_uz,
                        text:
                            this.$i18n.locale == "ru"
                                ? this.currentNews.title_ru
                                : this.currentNews.title_uz,
                        url: window.location.href,
                    })
                    .then(() => console.log("Удалось поделиться"))
                    .catch((error) =>
                        console.log("Не удалось поделиться", error)
                    );
            } else if (navigator.clipboard) {
                await navigator.clipboard.writeText(window.location.href);
                this.isClipBoard = true;

                setTimeout(() => {
                    this.isClipBoard = false;
                }, 2000);
            } else {
                alert("Ваш браузер не поддерживает функцию копирования ссылки");
            }
        },
    },
};
</script>
<style scoped>
.share {
    margin-top: 20px;
}
.extra_btn {
    position: relative;
    border: 1px solid #7f7f7f;
    border-radius: 4px;
    background: #58585882;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    height: 43px;
    width: 43px;
    backdrop-filter: blur(3px);

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
}

.extra_btn > img {
    width: 22px;
}

.extra_btn:hover {
    opacity: 0.7;
}

.extra_btn:first-child:hover {
    opacity: 1;
}

/* Clipboard - save link */
.save_clipboard {
    transition: 0.2s;
    opacity: 0;
    pointer-events: none;
}

.show_save_clipboard {
    opacity: 1;
}
.mobile {
    display: none;
}
.save_clipboard:before {
    content: attr(data-text);
    position: absolute;
    top: 0;
    right: 48px;
    font-size: 16px;
    font-weight: 400;
    text-wrap: nowrap;
    background: grey;
    border-radius: 4px;
    height: 100%;
    padding: 0 10px;
    display: flex;
    align-items: center;
}
/* --//-- Clipboard - save link */
.shareBtnWrapper {
    margin-top: 20px;
}
.disable_btn {
    pointer-events: none;
}
.wrapper {
    display: flex;
    max-width: 1280px;
    padding: 20px;
    margin: 0 auto;
    gap: 20px;
}
.left {
    width: calc(100% - 484px);
    padding: 0px 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.right {
    width: 388px;
}
.right img {
    width: 100%;
    border-radius: 7px;
    margin-top: 40px;
}
.left h1 {
    font-size: 40px;
    margin-bottom: 20px;
    line-height: 100%;
    color: #fff;
}
.left .date {
    color: #fff;
    font-size: 16px;
    line-height: 130%;
    padding: 10px;
    border-radius: 5px;
    background-color: #262626;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 43px;
}
.flexCont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    margin-bottom: 30px;
    width: 100%;
    padding-left: 5px;
}

.left .article {
    color: #fff;
    font-size: 18px;
    line-height: 130%;
    font-weight: 300;
}
@media (max-width: 940px) {
    .wrapper {
        flex-direction: column-reverse;
    }
    .left {
        width: 100%;
        padding: 0;
    }
    .right {
        width: 90%;
        margin: 0 auto;
    }
}
@media (max-width: 992px) {
    .mobile {
        display: flex;
        margin-top: 0;
    }
    .mobile .text {
        display: none;
    }
    .desctop {
        display: none;
    }
}

@media (max-width: 576px) {
    .left h1 {
        font-size: 28px;
        margin-bottom: 15px;
    }
    .left .date {
        font-size: 14px;
        padding: 8px;
    }
    .left .article {
        font-size: 16px;
    }
}
</style>
